import { logger } from './utils'

export function hoverImageTransition() {
  const archiveGridList = document.querySelector('.archive__grid-list')
  if (!archiveGridList) return logger.info('No Archive Grid List found. Maybe you are not on the Work Archive page?')
  const archiveList = archiveGridList.querySelectorAll('.archive__grid-item')

  const workBGImagesListEl = document.querySelector('.archive__work-bg-image-list')
  if (!workBGImagesListEl) return logger.error('No Work BG Images List found.')

  archiveList.forEach((archiveItem) => {
    const postID = archiveItem.getAttribute('data-archive-post-id')
    const currentImageWrapper = workBGImagesListEl?.querySelector(
      `[data-archive-post-id="${postID}"]`
    ) as HTMLImageElement | null
    if (!currentImageWrapper) return logger.error(`No Image found for post ID: ${postID}`)
    const image = currentImageWrapper.querySelector('img')
    if (!image) return logger.info(`No Image found for post ID: ${postID}`)
    archiveItem.addEventListener('mouseenter', () => {
      // check if image is loaded or not
      if (!image.complete) return logger.info(`Image is not loaded yet for post ID: ${postID}`)
      currentImageWrapper.style.opacity = '1'
    })
    archiveItem.addEventListener('mouseleave', () => {
      currentImageWrapper.style.opacity = '0'
    })
  })
}
